<template>
  <div>
    <MaintenanceHeader></MaintenanceHeader>
    <router-view />
    <div ref="scrollToTopButton" class="scrollToTopButton invisible">
      <button @click="scrollToTop">
        <i class="fas fa-arrows-up-to-line"></i>
      </button>
    </div>
  </div>
</template>


<script>
import MaintenanceHeader from '@/components/shared/MaintenanceHeader.vue';

export default {
  name: 'App',
  components: { MaintenanceHeader },
  data: function () {
    return { authenticated: false }
  },
  created () { 
    this.isAuthenticated();
    window.addEventListener("pageshow", function(event) {
      var historyTraversal = event.persisted || 
                         (typeof window.performance != "undefined" && 
                          window.performance.navigation.type === 2);
      if (historyTraversal) {
        // Handle page restore.
        window.location.reload();
      }
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    // Everytime the route changes, check for auth status
    '$route': 'isAuthenticated'
  },
  methods: {
    async isAuthenticated () {
      this.authenticated = await this.$auth.isAuthenticated()
    },
    handleScroll() {
      const scrollBtn = this.$refs.scrollToTopButton;
      if (window.scrollY > 0) {
          scrollBtn.classList.remove("invisible");
      } else {
          scrollBtn.classList.add("invisible");
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}
</script>

<style scoped src="@/assets/css/styles.css"></style>
<style scoped src="@/assets/css/fonts.css"></style>
<style>
  #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      font-size: .8em;
    }
</style>
